<template>
  <v-container
    v-scroll.html="onScroll"
    fluid
  >
    <v-slide-x-transition mode="out-in">
      <router-view />
    </v-slide-x-transition>
    <v-slide-y-transition mode="in-out">
      <v-btn
        style="z-index: 9999"
        v-show="offsetTop > 120"
        class="mx-2 d-print-none"
        @click="scrollToTop"
        fixed
        right
        bottom
        fab
        color="accent"
      >
        <v-icon> mdi-chevron-up </v-icon>
      </v-btn>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  name: "CoreView",
  components: {},
  props: {
    marging: String
  },
  data() {
    return {
      offsetTop: 0
    }
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.documentElement.scrollTop
    },
    scrollToTop() {
      this.$vuetify.goTo(0, {})
    }
  }
}
</script>

<style>
/* Customize printing  */
@media print {
  .v-main {
    display: block;
    page-break-inside: avoid !important;
  }
}
</style>
